module.exports = __webpack_public_path__ + "static/media/Service Information – Arabic@2x.08d905e9.jpg";